import React from 'react'

import { Checkbox } from 'src/components/ui'

import styles from './Checkboxes.module.scss'

const Checkboxes = ({ arrayOfCheckboxes, title }: { arrayOfCheckboxes: Array<string>; title: string }) => {
  const lengthOfArray = arrayOfCheckboxes.length

  return (
    <div className={styles.checkboxes}>
      <p className={styles.checkboxes_title}>{title}</p>
      <div className={`${styles.checkboxes_items} ${lengthOfArray > 3 ? styles.long : ''}`}>
        {arrayOfCheckboxes.map((checkbox) => (
          <Checkbox key={checkbox} title={checkbox} type={title} />
        ))}
      </div>
    </div>
  )
}

export default Checkboxes
